import { STUDIO_BRAND_LOGO } from '@/common/constants/studioPublicMedia';
import {
	AgeGateAccent,
	AgeGateBody,
	AgeGateBrand,
	AgeGateContent,
	AgeGateMessage,
	AgeGateTitle,
} from '../AgeGate.styles';
import AgeGatePromptActions from './AgeGatePromptActions';

const AgeGatePanel = ({
	translations,
	isBlocked,
	onConfirm,
	onDecline,
}) => (
	<AgeGateContent>
		<AgeGateBrand>
			<img src={STUDIO_BRAND_LOGO} alt="Soft AI" />
		</AgeGateBrand>
		<AgeGateBody>
			<AgeGateAccent />
			<AgeGateTitle id="age-gate-title">
				{isBlocked ? translations.blockedTitle : translations.title}
			</AgeGateTitle>
			<AgeGateMessage>
				{isBlocked ? translations.blockedMessage : translations.message}
			</AgeGateMessage>
			{!isBlocked ? (
				<AgeGatePromptActions
					translations={translations}
					onConfirm={onConfirm}
					onDecline={onDecline}
				/>
			) : null}
		</AgeGateBody>
	</AgeGateContent>
);

export default AgeGatePanel;
